import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04f3dc71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show-box" }

import {computed} from 'vue';
import {SelectFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { ColumnEdit } from '@/components/business/crud/widgets/TableWidgetContainer';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTable',
  props: {
    columnEdit: { type: Function },
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const option = computed(() => {
  for (const index in props.widget.options) {
    const option = props.widget.options[index];
    if (option.value === props.data[props.propName]) {
      return {
        index: Number(index) % 6,
        name: option.name,
      };
    }
  }
  return undefined;
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (option.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['style_' + option.value.index, "tag"])
        }, _toDisplayString(option.value.name), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})